import { insertTable as insertTable_1 } from 'owa-locstrings/lib/strings/inserttable.locstring.json';
import loc from 'owa-localize';
import * as React from 'react';
import { RibbonButton, RibbonDropDownProps } from './RibbonButton';
import { callFormatApi } from 'owa-editor/lib/utils/callApi';
import updateContentToViewState from 'owa-editor/lib/utils/updateContentToViewState';
import cacheEditorSelection from '../../utils/cacheEditorSelection';
import { InsertTableCallout } from 'owa-editor-ribbon-secondary-ui';

const insertTable: RibbonButton = {
    key: 'insertTable',
    title: () => loc(insertTable_1),
    imageSrc: require('../svg/table.svg'),
    createDropDownCallback: React.memo(
        ({ editorViewState, target, dismiss }: RibbonDropDownProps) => {
            const { restorer } = cacheEditorSelection(editorViewState);
            const onInsertTable = React.useCallback(
                (cols: number, rows: number) => {
                    restorer();
                    callFormatApi(editorViewState, 'insertTable', [cols, rows], [cols, rows]);
                    updateContentToViewState(editorViewState);
                },
                [editorViewState]
            );
            return (
                <InsertTableCallout
                    target={target}
                    onDismiss={dismiss}
                    onInsertTable={onInsertTable}
                />
            );
        }
    ),
};

export default insertTable;
